import { BOOK } from "../lib/content";

export const Marquee = () => {
  const items = [...BOOK.marquee, ...BOOK.marquee];
  return (
    <div className="border-y border-[#C5A059]/15 py-7 overflow-hidden bg-[#0d0d13]" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {items.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center whitespace-nowrap">
                <span className="font-serif-book italic text-lg sm:text-xl text-[#A19F9A] px-8">{item}</span>
                <span className="w-1.5 h-1.5 rotate-45 bg-[#C5A059]/50 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
